import { snackbar } from "@/core/controller/snackbar_controller";
import { headers } from '../const/headers';
import { serviceOrderDefault } from '../domain/serviceOrder/service_order.js'
import dayjs from "dayjs";

class ServiceOrderController {
    context = null;
    headers = headers;
    loading = false;
    search = "";
    dialog = false;
    form = serviceOrderDefault();
    searchClient = "";
    searchVehicle = "";
    searchTechnician = "";
    searchStatus = "";
    searchTaskType = "";
    searchVehicleInModal = "";
    searchClientInModal = "";
    searchTechnicianInModal = "";
    vehicleIDToInclude = null;
    clientIDToInclude = null;
    technicianIDToInclude = null;
    statusPaginated = 1;
    statusSelected = 1;
    statusList = [
        {text: 'Todos', value: 0},
        {text: 'Ativo', value: 1},
        {text: 'Inativo', value: 2}
    ];
  
    serviceOrderPagination = {
        total: 0,
        items: []
    }

    options = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["createdDate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: [true]
    }


    clientPagination = {
        total: 0,
        items: []
    }
    
    clientOptions = {
        page: 1,
        itemsPerPage: 100,
        groupBy: [],
        sortBy: ["name"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    vehiclePagination = {
        total: 0,
        items: []
    }
    
    vehicleOptions = {
        page: 1,
        itemsPerPage: 100,
        groupBy: [],
        sortBy: ["plate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    technicianPagination = {
        total: 0,
        items: []
    }
    
    technicianOptions = {
        page: 1,
        itemsPerPage: 100,
        groupBy: [],
        sortBy: ["name"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    statusPagination = {
        total: 0,
        items: []
    }

    statusOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["id"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    taskTypePagination = {
        total: 0,
        items: []
    }

    taskTypeOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["id"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    constructor(
        context,
        fetchClientUseCaseImpl,
        fetchVehicleUseCaseImpl,
        fetchServiceOrderUseCaseImpl,
        fetchTechnicianUseCaseImpl,
        createServiceOrderUsecaseImpl,
        changeServiceOrderUsecaseImpl,
        deleteServiceOrderUsecaseImpl,
        fetchTaskTypeUseCaseImpl,
        fetchStatusUseCaseImpl
    ) {
        this.context = context;
        this.fetchClientUseCaseImpl = fetchClientUseCaseImpl,
        this.fetchVehicleUseCaseImpl = fetchVehicleUseCaseImpl,
        this.fetchServiceOrderUseCaseImpl = fetchServiceOrderUseCaseImpl,
        this.fetchTechnicianUseCaseImpl = fetchTechnicianUseCaseImpl,
        this.createServiceOrderUsecaseImpl = createServiceOrderUsecaseImpl,
        this.changeServiceOrderUsecaseImpl = changeServiceOrderUsecaseImpl,
        this.deleteServiceOrderUsecaseImpl = deleteServiceOrderUsecaseImpl,
        this.fetchTaskTypeUseCaseImpl = fetchTaskTypeUseCaseImpl,
        this.fetchStatusUseCaseImpl = fetchStatusUseCaseImpl
    }

    async paginate() {
        this.loading = true
        try {
            this.serviceOrderPagination = await this.fetchServiceOrderUseCaseImpl(this.options, this.search, this.statusSelected)
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false
        }
    }
    async taskTypePaginate() {
        try {
            this.taskTypePagination = await this.fetchTaskTypeUseCaseImpl(this.taskTypeOptions, this.searchTaskType)
        } catch (error) {
            console.log(error);
        }
    }

    async clientPaginate() {
        try {
            const newPaginationData = await this.fetchClientUseCaseImpl(
                this.clientOptions,
                this.searchClient || this.searchClientInModal,
                this.statusPaginated,
                this.clientIDToInclude
            )

            const currentSelectedItem = this.clientPagination.items.find(
                (v) => v.id === this.form.clientID
            )

            if (currentSelectedItem && !newPaginationData.items.some(v => v.id === currentSelectedItem.id)) {
                newPaginationData.items.unshift(currentSelectedItem)
            }
            this.clientPagination = newPaginationData
        } catch (error) {
            console.log(error);
        }
    }

    async vehiclePaginate() {
        try {
            const newPaginationData = await this.fetchVehicleUseCaseImpl(
                this.vehicleOptions,
                this.searchVehicle || this.searchVehicleInModal,
                this.statusPaginated,
                this.vehicleIDToInclude
            )

            const currentSelectedItem = this.vehiclePagination.items.find(
                (v) => v.id === this.form.vehicleID
            )

            if (currentSelectedItem && !newPaginationData.items.some(v => v.id === currentSelectedItem.id)) {
                newPaginationData.items.unshift(currentSelectedItem)
            }
            this.vehiclePagination = newPaginationData
        } catch (error) {
            console.log(error);
        }
    }

    async technicianPaginate() {
        try {
            const newPaginationData = await this.fetchTechnicianUseCaseImpl(
                this.technicianOptions,
                this.searchTechnician || this.searchTechnicianInModal,
                this.statusPaginated,
                this.technicianIDToInclude
            )

            const currentSelectedItem = this.technicianPagination.items.find(
                (v) => v.id === this.form.technicianID
            )

            if (currentSelectedItem && !newPaginationData.items.some(v => v.id === currentSelectedItem.id)) {
                newPaginationData.items.unshift(currentSelectedItem)
            }
            this.technicianPagination = newPaginationData
        } catch (error) {
            console.log(error);
        }
    }
    async statusPaginate() {
        try {
            this.statusPagination = await this.fetchStatusUseCaseImpl(this.statusOptions, this.searchStatus)
        } catch (error) {
            console.log(error);
        }
    }

    async open() {
        this.dialog = true
        this.form = serviceOrderDefault()
        this.clientIDToInclude = null
        this.vehicleIDToInclude = null
        this.technicianIDToInclude = null
        this.searchVehicleInModal = ""
        this.searchClientInModal = ""
        this.searchTechnicianInModal = ""
        await Promise.all([
            this.vehiclePaginate(),
            this.clientPaginate(),
            this.technicianPaginate(),
            this.taskTypePaginate(),
            this.statusPaginate(),
        ]);
    }

    close() {
        this.dialog = false
        this.form = serviceOrderDefault()
        this.searchVehicleInModal = ""
        this.searchClientInModal = ""
        this.searchTechnicianInModal = ""
        this.vehicleIDToInclude = null
        this.clientIDToInclude = null
        this.technicianIDToInclude = null
    }

    async create() {
        if(this.context.$refs.crud.validate()) {
            try {
                this.loading = true

                this.form.startDate = dayjs(this.form.startDate).startOf('day').toISOString();
                this.form.endDate = dayjs(this.form.endDate).startOf('day').toISOString();

                if(this.form.id != 0) {
                    await this.changeServiceOrderUsecaseImpl(this.form.id, this.form)
                    snackbar.show({ message: "Alterado com sucesso!", color: "#008000", timeout: 3000 })
                } else {
                    await this.createServiceOrderUsecaseImpl(this.form)
                    snackbar.show({ message: "Adicionado com sucesso!", color: "#008000", timeout: 3000 })
                }
            } catch (error) {
                snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
            } finally {
                this.loading = false
                this.paginate()
                this.close()
            }
        }
    }

    async change(item) {
        this.dialog = true
        this.form = { ...item }
        this.searchClientInModal = item.clientName
        this.searchVehicleInModal = item.plate
        this.searchTechnicianInModal = item.technicianName
        this.clientIDToInclude = item.clientID
        this.vehicleIDToInclude = item.vehicleID
        this.technicianIDToInclude = item.technicianID

        if (item.clientID) {
            this.clientPagination.items = [{ id: item.clientID, name: item.clientName }]
        }
        if (item.vehicleID) {
            this.vehiclePagination.items = [{ id: item.vehicleID, plate: item.plate }]
        }
        if (item.technicianID) {
            this.technicianPagination.items = [{ id: item.technicianID, name: item.technicianName }]
        }

        await Promise.all([
            this.clientPaginate(),
            this.vehiclePaginate(),
            this.technicianPaginate(),
            this.taskTypePaginate(),
            this.statusPaginate(),
        ])
    }

    async delete(item) {
        try {
          const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
          if (confirm) {
            await this.deleteServiceOrderUsecaseImpl(item.id)
            this.paginate()
            snackbar.show({ message: "Resgistro excluído com sucesso!", color: "#008000", timeout: 1000 })
          }
        } catch (error) {
            snackbar.show({ message: error.toString() })
        } finally {
            this.paginate()
        }
    }

    changeStatus() {
        this.paginate()
    }
    watchOptions() {
        this.paginate()
    }
    watchSearch() {
        this.paginate()
    }
    watchClientOptions() {
        this.clientPaginate()
    }
    watchClientSearch() {
        this.clientPaginate()
    }
    watchClientSearchInModal() {
        this.clientPaginate()
    }
    watchVehicleOptions() {
        this.vehiclePaginate()
    }
    watchVehicleSearch() {
        this.vehiclePaginate()
    }
    watchVehicleSearchInModal() {
        this.vehiclePaginate()
    }
    watchTechnicianOptions() {
        this.technicianPaginate()
    }
    watchTechnicianSearch() {
        this.technicianPaginate()
    }
    watchTechnicianSearchInModal() {
        this.technicianPaginate()
    }
    watchTaskTypeOptions() {
        this.taskTypePaginate()
    }
    watchTaskTypeSearch() {
        this.taskTypePaginate()
    }
    watchStatusOptions() {
        this.statusPaginate()
    }
    watchStatusSearch() {
        this.statusPaginate()
    }
}

export default ServiceOrderController